import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=595f4707&scoped=true&"
import script from "./FormEdit.vue?vue&type=script&lang=ts&"
export * from "./FormEdit.vue?vue&type=script&lang=ts&"
import style0 from "./FormEdit.vue?vue&type=style&index=0&id=595f4707&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595f4707",
  null
  
)

export default component.exports